import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
@Component({
  selector: 'app-modal-generico',
  templateUrl: './modal-generico.component.html',
  styleUrls: ['./modal-generico.component.scss']
})
export class ModalGenericoComponent implements OnInit {

  @ViewChild('modal', { static: true }) modal: ElementRef<HTMLDivElement>  | undefined;
  @ViewChild('modalInfo', { static: true }) modalInfo: ElementRef<HTMLDivElement> | undefined;
  @Input() data: any;

  constructor() {}

  ngOnInit() {
  }

  show(){
    // @ts-ignore
    this.modal.nativeElement.classList.remove('d-none')
    // @ts-ignore
    this.modal.nativeElement.classList.add('d-flex')
  }

  hide(){
    // @ts-ignore
    this.modal.nativeElement.classList.remove('d-flex')
    // @ts-ignore
    this.modal.nativeElement.classList.add('d-none')
  }

  showModalInfo(){
    // @ts-ignore
    this.modalInfo.nativeElement.classList.remove('d-none')
    // @ts-ignore
    this.modalInfo.nativeElement.classList.add('d-flex')
  }

  hideModalInfo(){
    // @ts-ignore
    this.modalInfo.nativeElement.classList.remove('d-flex')
    // @ts-ignore
    this.modalInfo.nativeElement.classList.add('d-none')
  }


}
